import { defineStore } from 'pinia';
import { ref } from 'vue';
import axios from "axios";
import { useToastStore } from "@/stores/toastStore.js";

export const useCabinetStore = defineStore('cabinet-store',  () => {

  const toastStore = useToastStore()

  const cabinetId = ref()
  const cabinetData = ref({})

  function setCabinet(newCabinetId) {
    if (newCabinetId) {
      cabinetId.value = newCabinetId
      getCabinetData(newCabinetId)
      // getCabinetPermissions(cabinetId, userId)
    }
    else {
      cabinetId.value = null
      cabinetData.value = {}
      // cabinetPermissions.value = {}
    }
  }

  function getCabinetData(cabinetId) {
    axios.get(`/api/cabinets/${ cabinetId }`).then( r => cabinetData.value = r.data )
  }

  function updateCabinetData(cabinetId, newCabinetData) {
    axios.patch(`/api/cabinets/${ cabinetId }`, newCabinetData).then(r => {
      cabinetData.value = r.data
      toastStore.showToastMessage('Updated cabinet information', 'success', 'add')
    })
  }

  const cabinetColumnConfig = ref([{}])
  function getCabinetColumnConfig(cabinetId) {
    axios.get(`/api/cabinets/${ cabinetId }/column_config`).then( r => cabinetColumnConfig.value = r.data.column_config )
  }
  function updateCabinetColumnConfig(cabinetId, columnChanges) {
    axios.put(`/api/cabinets/${ cabinetId }/column_config`, columnChanges).then(r => {
      cabinetColumnConfig.value = r.data.column_config
    })
  }

  const userColumnConfig = ref([])
  const getUserColumnConfig = async (cabinetId) => {
    const { data } = await axios.get(`/api/cabinets/${cabinetId}/user_column_config`)
    const combinedColumnConfig = mergeReservedColumns(data)

    userColumnConfig.value = combinedColumnConfig
    return combinedColumnConfig
  }
  const saveUserColumnConfig = (state) => {
    const params = {
      cabinet_id: cabinetId.value,
      column_config: state.columns
    }

    axios.post(`/api/cabinets/${cabinetId.value}/user_column_config`, params)
  }

  // ensures that the reserved columns are present and merges in FE only reserved params
  const mergeReservedColumns = (columnConfig) => {
    let combinedColumnData = []
    for (const reservedColumn of reservedColumns.value) {
      const dataField = reservedColumn.dataField
      const existingColumn = columnConfig.find(userColumn => userColumn.dataField === dataField)
      if (!existingColumn)
        combinedColumnData.push({ ...reservedColumn });
    }
    for (const userColumn of columnConfig) {
      const dataField = userColumn.dataField
      const supplementalData = reservedColumns.value.find(reservedColumn => reservedColumn.dataField === dataField)
      combinedColumnData.push({ ...supplementalData, ...userColumn })
    }
    return combinedColumnData
  }

  // TODO: consider putting reservedColumns in another file
  const reservedColumns = ref([
    {
      'dataField': "selected",
      'headerCellTemplate': "select-header-template",
      'cellTemplate': "select-template",
      'showInColumnChooser': false,
      'allowEditing': false,
      'allowFiltering': false,
      'allowSorting': false,
      'allowReordering': false,
      'allowResizing': false,
      'width': 60,
      'minWidth': 60,
      'visible': true
    },
    {
      'caption': "Title",
      'dataField': "doc_title",
      'cellTemplate': "main-doc-cell",
      'showInColumnChooser': false,
      'allowEditing': false,
      'width': 500,
      'minWidth': 75,
      'visible': true
    },
    {
      'caption': "Document Date",
      'dataField': "doc_dt",
      'dataType': "date",
      'groupInterval': "day",
      'width': 160,
      'minWidth': 100,
      'visible': true
    },
    {
      'caption': "Page Count",
      'dataField': "page_count",
      'dataType': "number",
      'allowEditing': false,
      'width': 150,
      'minWidth': 100,
      'visible': true
    },
    {
      'caption': "Has Splits",
      'dataField': "has_split",
      'dataType': "boolean",
      'allowEditing': false,
      'width': 125,
      'minWidth': 100,
      'visible': true
    }
  ])

  return {
    cabinetId,
    cabinetData,
    cabinetColumnConfig,
    userColumnConfig,
    reservedColumns,
    setCabinet,
    updateCabinetData,
    getCabinetColumnConfig,
    updateCabinetColumnConfig,
    getUserColumnConfig,
    saveUserColumnConfig
  }
})
